import React from "react";

import { ApproveButton } from "../../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import Modal from "../../Modal/Modal";
import { InfoSelectPlanel } from "./infoSelectPanel";
import { Container } from "./modalOperationSuccesStyles";

export const ModalOperationSuccess = (props) => {
  const { toggleModal, haveBalance, params, balanceNum, paymentCurrency } =
    props;
  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container haveBalance={haveBalance} height="auto">
        <h1 className="title">Aprobación exitosa</h1>
        <label
          htmlFor="lab"
          className="subtitle"
          style={{ marginTop: "1.1rem" }}
        >
          Se ha realizado la aprobación del pago con código{" "}
          <b style={{ fontWeight: 600, color: "#08082B" }}>
            Nº {params.params.sidebarInfo.invoiceNum}.
          </b>
        </label>
        {haveBalance && (
          <React.Fragment>
            <label
              htmlFor="lab"
              className="subtitle"
              style={{
                marginTop: "3.3rem",
                opacity: 1,
                fontWeight: 500,
                color: "#08082B",
              }}
            >
              {params.params.dataFomr.operations.length > 1
                ? "Los números "
                : "El número "}
              de operación para este saldo a favor es:
            </label>
            <h1 style={{ fontSize: "2.8rem", marginBottom: 0 }}>
              <InfoSelectPlanel
                items={params.params.dataFomr.operations.map(
                  (operation) => operation.line.numeroOperacion
                )}
                height={"3.2rem"}
                widthPanel={"23.1rem"}
              ></InfoSelectPlanel>
            </h1>
            <label
              htmlFor="lab"
              className="subtitle "
              style={{ fontWeight: 500, color: "#08082B" }}
            >
              con un saldo a favor de {paymentCurrency === "usd" ? "$" : "S/"}{" "}
              {balanceNum}.
            </label>
          </React.Fragment>
        )}

        <div className="container-comment">
          <label htmlFor="lab" className="label-comment">
            COMENTARIO REGISTRADO
          </label>
          <p className="content-comment" style={{ height: "auto" }}>
            {params.params.comment}
          </p>
        </div>
        <div style={{ marginTop: "2.8rem", width: "100%" }}>
          <ApproveButton
            type="button"
            width="100%"
            onClick={() => {
              props.onOk();
            }}
          >
            Entendido
          </ApproveButton>
        </div>
      </Container>
    </Modal>
  );
};
